import axios from 'axios'

export const Api = axios.create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
            Accept: 'application/json',
        }
});

const token = "";
export function AffecteToken(token){
    this.token = token;
}
export let ApiToken = axios.create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
            Accept: 'application/json',
            token : token,
        }
});